export default "https://storage.googleapis.com/prepweb-prod/dist/5d95498a662a7744a19d4ad1340ded44.svg";